import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getSupabase } from "../components/supabaseClient"; // Ensure this is correctly imported
import { logo } from "../components/env";
import notes from "../assets/download.jpeg";
import writing from "../assets/writing.jpeg";
import "../css/LandingPage.css";

function LandingPage() {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuthStatus = async () => {
      const supabase = await getSupabase();
      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (session) {
        const { expires_at } = session;
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds

        if (expires_at && expires_at > currentTime) {
          setIsAuthenticated(true); // User is authenticated and token is still valid
          return true;
        }
      }
      return false;
    };

    checkAuthStatus().then((isA) => {
      if (isA) {
        navigate("/schedules"); // Directly navigate to audio-recorder if authenticated
      } else {
        navigate("/auth", { state: { authView: "sign_in" } });
      }
    });
  }, []);

  const handleGetStartedClick = () => {
    if (isAuthenticated) {
      navigate("/schedules"); // Directly navigate to audio-recorder if authenticated
    } else {
      navigate("/auth", { state: { authView: "sign_in" } });
    }
  };

  const handleLogInClick = () => {
    navigate("/auth", { state: { authView: "sign_in" } });
  };

  const handleLearnMoreClick = () => {
    const featureSection = document.querySelector(".feature-section");
    featureSection.scrollIntoView({ behavior: "smooth" }); // Scroll to the feature section
  };

  return (
    <div className="landing-page">
      <header className="head">
        <div className="logo-container">
          <img src={logo} alt="Yoda Labs Logo" className="logo-image" />
          <span className="logo-text">Yoda Labs</span>
        </div>
        {!isAuthenticated && (
          <button className="login-button" onClick={handleLogInClick}>
            Log In
          </button>
        )}
      </header>

      <section className="hero">
        <div className="hero-content">
          <h1>Magic Notes</h1>
          <p>Organize your thoughts, ideas, and tasks effortlessly</p>
          <div className="hero-buttons">
            <button
              className="get-started-button"
              onClick={handleGetStartedClick}
            >
              Get Started
            </button>
            <button
              className="learn-more-button"
              onClick={handleLearnMoreClick}
            >
              Learn More
            </button>
          </div>
        </div>
        <div className="hero-image">
          <img src={notes} alt="Notebook" />
        </div>
      </section>

      <section className="feature-section">
        <div className="feature-video">
          <video controls>
            <source src="your-video.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="feature-text">
          <h2>Introducing Magic Notes</h2>
          <p>
            The ultimate tool for capturing, transcribing, and transforming
            lectures into stunning notes within your preferred note-taking app
            like GoodNotes, Notability, or Notion.
          </p>
        </div>
      </section>

      <section className="description-section">
        <div className="description-text">
          <p>
            Whether you're a student, professional, or creative individual,
            Magic Notes is designed to streamline your note-taking process and
            enhance your productivity.
          </p>
        </div>
        <div className="description-image">
          <img src={writing} alt="Writing" />
        </div>
      </section>

      <footer className="foot">
        <p>
          For any issues with the app or comments contact support@magicnotes.ai
        </p>
      </footer>
    </div>
  );
}

export default LandingPage;
